import { Table } from "./table";
import { Row } from "./row";
import { Cell } from "./cell";
import { Action } from "./action";

const Component = Object.assign(Table, {
  Row: Row,
  Cell: Cell,
  Action: Action,
});

export { Component as Table };
